import { useEffect, useState } from 'react';

export const CONTENT_LOADING_DELAY_MS = 2000;

export default function useDelayedLoading() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const timeout = setTimeout(
      () => setVisible(true),
      CONTENT_LOADING_DELAY_MS,
    );
    return () => clearTimeout(timeout);
  }, []);
  return visible;
}
